import { RulesDocumentTeacherType } from "../../../types/Teacher";
import { post } from "../../../utils/axios-config";
import { RULES_DOCUMENT_TEACHER } from "../../../utils/constants";

export const createTeacherRequiredDocument = async (data: RulesDocumentTeacherType) => await post<RulesDocumentTeacherType, string>(RULES_DOCUMENT_TEACHER, data);
